__turbopack_context__.v({
  "circle": "PriceRatingGauge-module__dgrkuG__circle",
  "clickable": "PriceRatingGauge-module__dgrkuG__clickable",
  "experiment": "PriceRatingGauge-module__dgrkuG__experiment",
  "fair": "PriceRatingGauge-module__dgrkuG__fair",
  "gauge": "PriceRatingGauge-module__dgrkuG__gauge",
  "good": "PriceRatingGauge-module__dgrkuG__good",
  "great": "PriceRatingGauge-module__dgrkuG__great",
  "label": "PriceRatingGauge-module__dgrkuG__label",
  "priceRating": "PriceRatingGauge-module__dgrkuG__priceRating",
  "scoreArrow": "PriceRatingGauge-module__dgrkuG__scoreArrow",
});
